import domain_checker from '../photos/Domain_Checker.jpg';
import SIP from '../photos/SIP_Hero_Section.PNG'
import requiter from '../photos/requiter.PNG'
import school_MS from '../photos/school_MS.PNG'
import Distributed from '../photos/Distributed_Elastic_Teamwork_Hero_section.PNG'
import { SiAxios, SiChartdotjs, SiCloudinary, SiDjango, SiExpress, SiJest, SiMongodb, SiMui, SiPostcss, SiPython, SiReact, SiReactrouter, SiRedux, SiTailwindcss, SiVite } from 'react-icons/si';
import spice_island from '../photos/restaurant_web.PNG'
import { IoLogoNodejs } from 'react-icons/io';
import { TbApi, TbBrandTypescript } from 'react-icons/tb';
import { RiFirebaseFill, RiGeminiFill, RiJavascriptFill, RiNextjsLine, RiOpenaiFill, RiTailwindCssFill } from 'react-icons/ri';
import { LuFramer } from 'react-icons/lu';
import { VscEllipsis } from "react-icons/vsc";
import Youtube_clone from '../photos/Youtube_clone.PNG'
import Alibaba_clone from '../photos/Alibaba_clone.PNG'
import CV_maker from '../photos/CV_maker.PNG'
import portfolio from '../photos/portfolio.PNG'
import { FaCss3Alt, FaHtml5 } from 'react-icons/fa';
import { MdOutlinePayment } from 'react-icons/md';
import whatsapp_clone from '../photos/whatsapp_clone.jpg'
import pernia from '../photos/pernia.PNG'

let library;
export default library = [
    {
        title: "Domain Availability Checker",
        description: "A modern webapp that checks availability of domain name using both popular and unpopular TLDs, it has a sleek claymorphic design, and It provides instant feedback.",
        image: domain_checker,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [FaHtml5, FaCss3Alt, RiJavascriptFill, TbApi],
        github: "https://github.com/Snotat/Domain_Checker",
        live: "https://domaincheckerbysnotat.netlify.app/"
    },
    {
        title: "Smart Inventory & Pricing",
        description: "A dashboard that helps small and middle size businesses to optimize their pricing and inventory, with built in AI powered business insights and advisory system.",
        image: SIP,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [SiReact, SiExpress, SiJest, RiGeminiFill, SiChartdotjs, SiAxios
        ],
        github: "https://github.com/Snotat/feqqapp",
        live: "https://sip-web.netlify.app"
    },
    {
        title: "Requiter Jobs",
        description: "A solo freelance project where I'm building an enterprise level recruitment system with functionalities like automated screening, interview, and automated testing and scoring.",
        image: requiter,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [RiNextjsLine,RiTailwindCssFill, SiRedux, SiMongodb, SiExpress, SiJest,
        ],
        live: "https://requiterjobsapp.vercel.app/"
    },
    {
        title: "Student Management Front",
        description: "Working on an students & teachers management web app for mid-schools with some experts, where I implemented state management with redux-toolkit & build components.",
        image: school_MS,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [ RiNextjsLine, RiTailwindCssFill, SiMongodb,SiCloudinary, SiExpress, SiJest,
        ],
        live: "https://student-management-front.vercel.app/"
    },
    {
        title: "Pernia's Shop",
        description: "Collaborated with a team of developers and designers to build a unique clothing store for a big indian brand, built modern user interface and sophisticated servers.",
        image: pernia,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [SiReact, SiMui,SiRedux, SiMongodb,SiCloudinary, SiExpress, SiJest,
        ],
        live: "https://www.perniaspopupshop.com/"
    },
    {
        title: "My YouTube",
        description: "About a year ago, I built a clone of the biggest video sharing and streaming platform. My recreation of a few pages captures the spirit, but the original is obviously singular.",
        image: Youtube_clone,
        tools: ["React", "TailwindCSS", "Claymorphism", "API Integration"],
        icons: [SiReact, SiReactrouter, RiTailwindCssFill,],
        github: "https://github.com/snotat",
        live: "https://youtubeclonebysnotat.netlify.app"
    },
    {
        title: "Spice Island Grill Kitchen",
        description: "A full-stack restaurant web app for Spice Island Grill Kitchen, cobuilt an intuitive and responsive food ordering experience, and integrated with an API from a Django server.",
        image: spice_island,
        tools: ["Vite", "React", "TailwindCSS", "Django (API)", "Axios", "React Router"],
        icons: [SiVite, TbBrandTypescript, SiMui, LuFramer, SiCloudinary, VscEllipsis],
        github: "",
        live: "https://restaurant-web-rd79.onrender.com/"
    },
    {
        title: "Distributed",
        description: "A UK based corporate level tech talent outsourcer, basically where companies meet with teams of various IT expert to address IT problems. Cobuilt with many other talents.",
        image: Distributed,
        tools: ["Vite", "React", "TailwindCSS", "Django (API)", "Axios", "React Router"],
        icons: [RiNextjsLine, TbBrandTypescript, RiTailwindCssFill, LuFramer, SiCloudinary, VscEllipsis],
        github: "",
        live: "https://distributed.com"
    },
    {
        title: "My Alibaba",
        description: "I built a clone of the global ecommerce giant, Alibaba. tried to replicate as many functionalities as possible like integrating payment gateway, I learnt a lot from this build",
        image: Alibaba_clone,
        tools: ["Vite", "React", "TailwindCSS", "Django (API)", "Axios", "React Router"],
        icons: [RiNextjsLine, TbBrandTypescript, RiTailwindCssFill, LuFramer, SiCloudinary, MdOutlinePayment, VscEllipsis],
        github: "https://github.com/snotat",
        live: "https://alibabaclonebysnotat.vercel.app/"
    },
    {
        title: "CV maker",
        description: "A Curriculum Vitae (Resume) maker, with have functionalities like CV to portfolio web app to cover letter, integrated openai API to handle some logic and processing.",
        image: CV_maker,
        tools: ["Vite", "React", "TailwindCSS", "Axios", "React Router"],
        icons: [RiNextjsLine, RiTailwindCssFill, SiPostcss, RiOpenaiFill, SiRedux, SiExpress,
        ],
        github: "https://github.com/snotat",
        live: "https://nicecvmaker.vercel.app"
    },
    {
        title: "My Whatsapp Web",
        description: "I'm trying to build a clone of the most popular messaging platform, I implemented firebase to handle the server-side aspect, React handle the frontend and Google Auth for signin.",
        image: whatsapp_clone,
        tools: ["React", "TailwindCSS", "Axios", "React Router"],
        icons: [SiReact, RiTailwindCssFill, RiFirebaseFill, SiRedux, SiExpress,
        ],
        github: "https://github.com/snotat",
        live: "https://whatsapclonebysnotat.netlify.app"
    },
    {
        title: "My Portfolio",
        description: "A full-stack webapp built with the glassmorphism in mind - A modern UI trend. Built a server that stores messages, sends email alerts and API for admin section.",
        image: portfolio,
        tools: ["Vite", "React", "TailwindCSS", "Django (API)", "Axios", "React Router"],
        icons: [SiReact, RiTailwindCssFill, SiExpress,
        ],
        github: "https://github.com/snotat",
        live: "https://snotat.netlify.com/"
    }
]